import React, { useState } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { useUser } from '../userContext';

export default function ProfileLoadError() {
  const { retryLoadProfile, profileError } = useUser();
  const [retrying, setRetrying] = useState(false);

  const handleRetry = async () => {
    if (retrying) return;
    setRetrying(true);
    try {
      retryLoadProfile?.();
    } finally {
      setTimeout(() => setRetrying(false), 1500);
    }
  };

  const handleSignOut = () => {
    signOut(getAuth()).catch(() => {});
  };

  const message = profileError?.message || 'Could not load your workspace.';

  return (
    <div className="admin-theme gch-layout-bg gch-page min-h-screen flex items-center justify-center px-6">
      <div className="gch-card max-w-sm w-full px-6 py-7 text-center">
        <h1 className="gch-heading-sm mb-2">Something went wrong</h1>
        <p className="text-sm gch-text-secondary mb-5">{message} You're still signed in. This is usually a temporary network issue.</p>
        <div className="space-y-2">
          <button
            type="button"
            onClick={handleRetry}
            disabled={retrying}
            className="w-full btn-admin-primary btn-admin-md disabled:opacity-60"
          >
            {retrying ? 'Retrying…' : 'Try again'}
          </button>
          <button
            type="button"
            onClick={handleSignOut}
            className="w-full btn-admin-outline btn-admin-sm"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
